import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAuthToken(token) {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("atm_admin_token", token);
    } else {
        delete api.defaults.headers.common["Authorization"];
        localStorage.removeItem("atm_admin_token");
    }
}

const stored = typeof window !== "undefined" ? localStorage.getItem("atm_admin_token") : null;
if (stored) {
    api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

export const BRAND = {
    // Standalone icon mark (clean, transparent) — primary brand asset.
    // Self-hosted under /public/assets/brand/ to be immune to CDN cache hiccups.
    logo: "/assets/brand/logo-icon.png?v=5",
    logoWhite: "/assets/brand/logo-icon-white.png?v=5",
    // Readable lock-up for dark/navy backgrounds (footer)
    logoFooter: "/assets/brand/logo-footer.png?v=5",
    // Legacy full lock-up (icon + wordmark) — kept for fallback
    logoFull: "/assets/brand/logo-full.png?v=5",
    illustration: "/assets/brand/hero-illustration.png?v=5",
    illustrationWebp: "/assets/brand/hero-illustration.webp?v=5",
    photos: {
        toronto:
            "https://images.unsplash.com/photo-1704391897908-96b2f103c412?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHx0b3JvbnRvJTIwc2t5bGluZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzgxNzQ5NDR8MA&ixlib=rb-4.1.0&q=85",
        apartment:
            "https://images.unsplash.com/photo-1769063238167-d00e112147c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxlbXB0eSUyMG1vZGVybiUyMGFwYXJ0bWVudCUyMGludGVyaW9yfGVufDB8fHx8MTc3ODE3NDk0NHww&ixlib=rb-4.1.0&q=85",
        boxes:
            "https://images.unsplash.com/photo-1700165644892-3dd6b67b25bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjYXJkYm9hcmQlMjBib3glMjBtb3Zpbmd8ZW58MHx8fHwxNzc4MTc0OTQ4fDA&ixlib=rb-4.1.0&q=85",
    },
};

export const SERVICES = [
    {
        key: "free_consultation",
        title: "Free 20-Minute Consultation",
        price: "Free",
        priceNote: "Up to 20 minutes",
        type: "free",
        short: "A quick call to understand your move and recommend the best next step.",
        cta: "Book Free Consultation",
    },
    {
        key: "paid_consultation",
        title: "Paid Relocation Consultation",
        price: "$75",
        priceNote: "per hour",
        type: "paid",
        short:
            "A deeper planning session for clients who need structured guidance around timeline, options, and support needs.",
        cta: "Book Paid Consultation",
    },
    {
        key: "shortlisting",
        title: "Rental Shortlisting Support",
        price: "$150",
        priceNote: "2 hours included",
        type: "paid",
        short:
            "We help narrow down options based on your location, timing, budget, and move-related needs.",
        cta: "Request Shortlisting",
    },
    {
        key: "viewing_on_behalf",
        title: "Viewing on Behalf",
        price: "$300",
        priceNote: "4 hours, up to 3 viewings",
        type: "paid",
        short:
            "For clients who cannot attend in person, we attend local viewings and share practical observations where permitted.",
        cta: "Request Viewing Support",
    },
    {
        key: "move_day_4h",
        title: "Move-Day Coordination",
        price: "From $200",
        priceNote: "Choose 2 / 4 / 6 / 8 / 10 hour blocks",
        type: "paid",
        short:
            "We help coordinate timing, vendors, access, movers, elevators, and updates during your selected time block.",
        cta: "Book Move-Day Support",
    },
    {
        key: "packing_support",
        title: "Packing Support Coordination",
        price: "Quote-based",
        priceNote: "Confirmed before booking",
        type: "quote",
        short:
            "We help coordinate packing support through available vendors or helpers based on scope and timing.",
        cta: "Request Packing Support",
    },
    {
        key: "cleaning_support",
        title: "Cleaning Support Coordination",
        price: "Quote-based",
        priceNote: "Confirmed before booking",
        type: "quote",
        short:
            "We help coordinate move-in or move-out cleaning support based on property size, timing, and vendor availability.",
        cta: "Request Cleaning Support",
    },
    {
        key: "vendor_coordination",
        title: "Local Vendor Coordination",
        price: "Quote-based",
        priceNote: "Or included where relevant",
        type: "quote",
        short: "We help connect and coordinate local service providers where appropriate.",
        cta: "Request Vendor Coordination",
    },
    {
        key: "landlord_connection",
        title: "Landlord-Client Connection Support",
        price: "Included",
        priceNote: "Where relevant with shortlisting / viewing",
        type: "quote",
        short:
            "Where appropriate, we help connect you with the landlord or listing contact so communication can continue clearly.",
        cta: "Request Support",
    },
    {
        key: "custom_quote_payment",
        title: "Custom Quote Payment",
        price: "Enter amount",
        priceNote: "Approved quote amount",
        type: "custom",
        short: "Use this option to pay a custom quote amount approved by AllTask Moves.",
        cta: "Pay Custom Quote",
    },
];

export const MOVE_DAY_TIERS = [
    { key: "move_day_2h", label: "2 hours", amount: 200 },
    { key: "move_day_4h", label: "4 hours", amount: 300 },
    { key: "move_day_6h", label: "6 hours", amount: 400 },
    { key: "move_day_8h", label: "8 hours", amount: 500 },
    { key: "move_day_10h", label: "10 hours", amount: 600 },
];

export const TIME_SLOTS = [
    "9:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
    "4:00 PM",
    "5:00 PM",
    "6:00 PM",
];
